
  // video-block-hero [Versa Pack Plus Page]
document.addEventListener('DOMContentLoaded', function () {
  if (typeof window.jQuery !== 'function') return;

  /* ================================
     Main carousel
  ================================= */

const carousels = document.querySelectorAll('.underseat-tote-carousel');

carousels.forEach((carousel) => {
  if (!carousel.classList.contains('slick-initialized')) {
    window.jQuery(carousel).slick({
      dots: true,
      arrows: true,
      loop: false,
      infinite: false,
      speed: 1000,
      slidesToShow: 1,
      slidesToScroll: 1,
      prevArrow: `
        <button type="button" class="slick-arrow prev-arrow" aria-label="Previous slide" title="Previous slide">
          <svg width="15" height="32" viewBox="0 0 15 32" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true" focusable="false">
            <path d="M13.333 1L1.99968 15.5588L13.333 30.1176" stroke="black" stroke-width="3"/>
          </svg>
        </button>`,
      nextArrow: `
        <button type="button" class="slick-arrow next-arrow" aria-label="Next slide" title="Next slide">
          <svg width="16" height="31" viewBox="0 0 16 31" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true" focusable="false">
            <path d="M1.88867 0.941406L13.222 15.5002L1.88867 30.0591" stroke="black" stroke-width="3"/>
          </svg>
        </button>`
    });
  }
});


  /* ================================
     Linked carousels
  ================================= */

const subSeatWrappers = document.querySelectorAll('.inner-right-content');

subSeatWrappers.forEach((wrapper) => {
  const mainSubCarousel = wrapper.querySelector('.sub-underseat_carousel');
  const thumbCarousel   = wrapper.querySelector('.sub-underseat_thumb_carousel');

  if (
    !mainSubCarousel ||
    !thumbCarousel ||
    mainSubCarousel.classList.contains('slick-initialized')
  ) return;

  // Main carousel
  window.jQuery(mainSubCarousel).slick({
    draggable: false,
    slidesToShow: 1,
    slidesToScroll: 1,
    arrows: false,
    infinite: false,
    accessibility: false,
    swipeToSlide: false,
    swipe: false,
    asNavFor: thumbCarousel
  });

  // Thumbnail carousel
  window.jQuery(thumbCarousel).slick({
    draggable: false,
    infinite: false,
    slidesToShow: 5,
    slidesToScroll: 1,
    arrows: true,
    dots: false,
    swipe: false,
    focusOnSelect: true,
    asNavFor: mainSubCarousel,
    prevArrow: `
      <button type="button" class="slick-arrow prev-arrow" aria-label="Previous slide" title="Previous slide">
        <svg width="15" height="32" viewBox="0 0 15 32" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true" focusable="false">
          <path d="M13.333 1L1.99968 15.5588L13.333 30.1176" stroke="black" stroke-width="3"/>
        </svg>
      </button>`,
    nextArrow: `
      <button type="button" class="slick-arrow next-arrow" aria-label="Next slide" title="Next slide">
        <svg width="16" height="31" viewBox="0 0 16 31" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true" focusable="false">
          <path d="M1.88867 0.941406L13.222 15.5002L1.88867 30.0591" stroke="black" stroke-width="3"/>
        </svg>
      </button>`,
    responsive: [
      {
        breakpoint: 1024,
        settings: {
          arrows: true,
          swipe: false,
          slidesToShow: 4,
        }
      },
      {
        breakpoint: 769,
        settings: {
          slidesToShow: 4,
          arrows: false,
          swipe: true,
        }
      },
      {
        breakpoint: 320,
        settings: {
          slidesToShow: 4,
          arrows: false,
          swipe: true,
        }
      }
    ]
  });
});


});


  // table slider start here

document.addEventListener('DOMContentLoaded', function () {
  if (typeof window.jQuery !== 'function') return;

  document.querySelectorAll('.compare-pro-tab').forEach(slider => {
    const $slider = jQuery(slider);


    if ($slider.hasClass('slick-initialized')) return;

    $slider.slick({
      dots: false,
      infinite: false,
      speed: 300,
      slidesToShow: 5,
      slidesToScroll: 1,
      responsive: [
        {
          breakpoint: 991,
          settings: {
            slidesToShow: 4,
            slidesToScroll: 1
          }
        },
        {
          breakpoint: 768,
          settings: {
            slidesToShow: 3,
            slidesToScroll: 1
          }
        }
      ]
    });
  });
});

// Arrow Hide/Show for versapack-plus slider
document.querySelectorAll('.sub-underseat_thumb_carousel').forEach(function (carousel) {
  const arrows = carousel.querySelectorAll('.slick-arrow').length;
  const maxSlides = 4;

  if (maxSlides <= arrows || arrows === maxSlides) {
    carousel.querySelectorAll('.slick-arrow').forEach(arrow => {
      arrow.style.display = 'none';
    });
  } else {
    carousel.querySelectorAll('.slick-arrow').forEach(arrow => {
      arrow.style.display = '';
    });
  }
});

// Update the slider images based on the variant (versapack-plus)

let newImages = [];
document.addEventListener('click', function (e) {
  const swatch = e.target.closest('.product_swatches .swatch');
  if (!swatch) return;

  e.preventDefault();
  newImages = [];

  const variantUrl = swatch.getAttribute('data-url');
  if (!variantUrl) return;

  fetch(variantUrl)
    .then(res => res.text())
    .then(response => {
      const parser = new DOMParser();
      const doc = parser.parseFromString(response, 'text/html');

      // Collect images from fetched HTML
      doc
        .querySelectorAll(
          '.media-gallery__grid .product-media-container--image .product-media img'
        )
        .forEach(img => {
          if (img.src) newImages.push(img.src);
        });

      const slideContent = swatch.closest('.slide-content');
      if (!slideContent) return;

      const thumbCarousel = slideContent.querySelector('.sub-underseat_thumb_carousel');
      const mainCarousel = slideContent.querySelector('.sub-underseat_carousel');

      // Unslick + clear
      if (thumbCarousel && window.jQuery && jQuery(thumbCarousel).hasClass('slick-initialized')) {
        jQuery(thumbCarousel).slick('unslick');
        thumbCarousel.innerHTML = '';
      }

      if (mainCarousel && window.jQuery && jQuery(mainCarousel).hasClass('slick-initialized')) {
        jQuery(mainCarousel).slick('unslick');
        mainCarousel.innerHTML = '';
      }

      // Build slides
      const thumbSlides = newImages.map(imageUrl => `
        <div>
          <div class="thumb-slide-content">
            <div class="thumb_product-image">
              <img src="${imageUrl}">
            </div>
          </div>
        </div>
      `).join('');

      const mainSlides = newImages.map(imageUrl => `
        <div>
          <div class="innner-slide-content">
            <div class="product-image">
              <img src="${imageUrl}" alt="Product Image">
            </div>
          </div>
        </div>
      `).join('');

      if (thumbCarousel) thumbCarousel.innerHTML = thumbSlides;
      if (mainCarousel) mainCarousel.innerHTML = mainSlides;

      // Re-init Slick (existing functions)
      if (typeof versThumb === 'function') {
        versThumb(jQuery(thumbCarousel));
      }

      if (typeof versMainImg === 'function') {
        versMainImg(jQuery(mainCarousel));
      }
    });
});


function versMainImg($carousel) {
  $carousel.slick({
      slidesToShow: 1,
      slidesToScroll: 1,
      arrows: false,
      fade: false,
      asNavFor: '.sub-underseat_thumb_carousel',
      draggable: false,
      infinite: false,
  });
}

function versThumb($carousel) {
  $carousel.slick({
      infinite: false,
      slidesToShow: 4,
      slidesToScroll: 1,
      asNavFor: '.sub-underseat_carousel',
      arrows: true,
      dots: false,
      draggable: false,
      centerMode: false,
      focusOnSelect: true,
      centerPadding: '30px',
      prevArrow: '<button type="button" class="slick-arrow prev-arrow" aria-label="Previous slide" title="Previous slide"><svg width="15" height="32" viewBox="0 0 15 32" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true" focusable="false"><path d="M13.333 1L1.99968 15.5588L13.333 30.1176" stroke="black" stroke-width="3"/></svg></button>',
      nextArrow: '<button type="button" class="slick-arrow next-arrow" aria-label="Next slide" title="Next slide"><svg width="16" height="31" viewBox="0 0 16 31" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true" focusable="false"><path d="M1.88867 0.941406L13.222 15.5002L1.88867 30.0591" stroke="black" stroke-width="3"/></svg></button>',
  });
}

// Chnage the status of the active swatch (versapack-plus)

document.addEventListener('click', function (e) {
  const swatch = e.target.closest('.colors.swatch');
  if (!swatch) return;

  e.preventDefault();

  const swatchList = swatch.closest('.swatch_list');
  if (swatchList) {
    swatchList
      .querySelectorAll('.colors.swatch')
      .forEach(el => el.classList.remove('active'));
  }

  swatch.classList.add('active');
  const imgSrc = swatch.getAttribute('data-img');

  const itemWrapper = swatch.closest('.item_wrapper');
  const image = itemWrapper?.querySelector('img');

  if (image && imgSrc) {
    image.src = imgSrc;
  }
});


// video-block-hero [Versa Pack Plus Page]
document.querySelectorAll('.versapackplus-media').forEach(media => {
  media.addEventListener('click', () => {
    const section = media.closest('.versapackplus-hero-section');

    // Find visible video (desktop or mobile)
    const video = [...media.querySelectorAll('video')]
      .find(v => v.offsetParent !== null);

    if (!video) return;

    const playBtn = media.querySelector('.play-pause-btn');
    const logo = section && section.querySelector('.logo-with-title');

    if (video.paused) {
      video.play();
      playBtn && (playBtn.style.display = 'none');
      logo && (logo.style.display = 'none');
    } else {
      video.pause();
      playBtn && (playBtn.style.display = 'block');
      logo && (logo.style.display = 'block');
    }
  });
});

// Warranty Section Page Faq Start 

document.addEventListener("DOMContentLoaded", () => {
  document.querySelectorAll(".set > h3").forEach(h3 => {
    h3.addEventListener("click", () => {
      const box = h3.closest(".accordion-container");

      if (h3.classList.contains("active")) {
        h3.classList.remove("active");
        h3.nextElementSibling.style.display = "none";
      } else {
        box.querySelectorAll(".set > h3").forEach(el => el.classList.remove("active"));
        box.querySelectorAll(".content").forEach(el => el.style.display = "none");

        h3.classList.add("active");
        h3.nextElementSibling.style.display = "block";
      }
    });
  });
});


// Wrrap the class for table ".rte__table-wrapper"

var tables = document.querySelectorAll('.rte table');

tables.forEach(function (table) {
  // Prevent double wrapping
  if (table.parentElement.classList.contains('rte__table-wrapper')) return;

  var wrapper = document.createElement('div');
  wrapper.className = 'rte__table-wrapper';

  table.parentNode.insertBefore(wrapper, table);
  wrapper.appendChild(table);
});


// Durability video play JS

document.body.addEventListener('click', function (e) {
  var playIcon = e.target.closest('.play_icon');
  if (!playIcon) return;

  var video = document.querySelector('.custom_video');
  if (!video) return;

  if (video.paused) {
    video.play();
    playIcon.classList.add('playing');
  } else {
    video.pause();
    playIcon.classList.remove('playing');
  }
});


  // product List slider JS
document.addEventListener('DOMContentLoaded', function () {
  if (window.Shopify?.designMode) return;
  if (typeof window.jQuery !== 'function') return;

  var sliders = document.querySelectorAll('.product__list__slider.has_slider');
  if (sliders.length === 0) return;

  sliders.forEach(function (slider) {
    window.jQuery(slider).slick({
      dots: false,
      arrows: true,
      infinite: true,
      speed: 300,
      slidesToShow: 4,
      slidesToScroll: 1,
      prevArrow:
        '<button type="button" class="slick-prev">' +
        '<svg width="9" height="17" viewBox="0 0 9 17" fill="none" xmlns="http://www.w3.org/2000/svg">' +
        '<path d="M7.6665 1L0.999837 8.5L7.6665 16" stroke="#171717"></path>' +
        '</svg>' +
        '</button>',
      nextArrow:
        '<button type="button" class="slick-next">' +
        '<svg width="9" height="17" viewBox="0 0 9 17" fill="none" xmlns="http://www.w3.org/2000/svg">' +
        '<path d="M1 1L7.66667 8.5L1 16" stroke="#171717"></path>' +
        '</svg>' +
        '</button>',
      responsive: [
        {
          breakpoint: 992,
          settings: {
            slidesToShow: 3,
            centerMode: false
          }
        },
        {
          breakpoint: 768,
          settings: {
            slidesToShow: 2,
            centerMode: false
          }
        },
        {
          breakpoint: 426,
          settings: {
            slidesToShow: 1,
            centerMode: false
          }
        }
      ]
    });
  });
});

   // Packing Accessories Carousel [Versa Pack Plus]
document.addEventListener("DOMContentLoaded", () => {
  if (typeof window.jQuery !== 'function') return;

  const sliders = document.querySelectorAll('.packing-accessories-carousel');
  if (!sliders.length) return;

  sliders.forEach(slider => {
    window.jQuery(slider).slick({
      dots: false,
      arrows: true,
      infinite: false,
      speed: 1000,
      slidesToShow: 3,
      slidesToScroll: 1,

      
      prevArrow:
        '<button type="button" class="slick-arrow prev-arrow" aria-label="Previous slide">' +
        '<svg width="15" height="32" viewBox="0 0 15 32" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true" focusable="false">'+
        '<path d="M13.333 1L1.99968 15.5588L13.333 30.1176" stroke="black" stroke-width="3"/></svg></button>',

      nextArrow:
        '<button type="button" class="slick-arrow next-arrow" aria-label="Next slide">' +
        '<svg width="16" height="31" viewBox="0 0 16 31" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true" focusable="false">'+
        '<path d="M1.88867 0.941406L13.222 15.5002L1.88867 30.0591" stroke="black" stroke-width="3"/></svg></button>',

      responsive: [
        { breakpoint: 1024, settings: { slidesToShow: 3 } },
        { breakpoint: 769, settings: { slidesToShow: 2 } },
        { breakpoint: 480, settings: { slidesToShow: 1 } }
      ]
    });
  });
});


  
// versapackplus plus end js

const slickSettings = {
  autoplay: false,
  infinite: false,
  cssEase: "linear",
  slidesToShow: 2,
  arrows: false,
  dots: false,
  slidesToScroll: 1,
  responsive: [
    {
      breakpoint: 575,
      settings: {
        slidesToShow: 1,
        slidesToScroll: 1
      }
    }
  ]
};

window.addEventListener("load", () => {
  if (typeof window.jQuery !== 'function') return;

  const sliders = document.querySelectorAll(
    ".feature-slider.mobile_active_slider"
  );

  const toggleSlider = () => {
    const isMobile = window.matchMedia("(max-width: 768px)").matches;

    sliders.forEach((slider) => {
      const isInitialized = slider.classList.contains("slick-initialized");

      if (isMobile && !isInitialized) {
        window.jQuery(slider).slick(slickSettings);
      }

      if (!isMobile && isInitialized) {
        window.jQuery(slider).slick("unslick");
      }
    });
  };

  toggleSlider();
  window.addEventListener("resize", toggleSlider);
});




  var items = document.querySelectorAll('.template-page .quick-nav-item');
  items.forEach(function (item) {
    item.addEventListener('click', function (e) {
      e.preventDefault();

      var handle = this.getAttribute('data-handle');
      var target = document.getElementById(handle);
      console.log(handle);
      if (!target) return;

      var headerHeight = document.querySelector('#header-component')?.offsetHeight || 0;
      window.scrollTo({
        top: target.offsetTop - headerHeight,
        behavior: 'smooth'
      });
    });
  });

  // New Hero slider - initialization moved to inline script in new-hero-slider.liquid
  // for autoplay, WCAG, and multi-slide support with section settings access.


  

  


  

// Videowise PDP widget: the "Videos" title is hard-coded in the app block embed, but the widget
// renders into a closed shadow root and stays 0px tall when a product has no videos. Show the
// title only once the widget next to it has height.
(function () {
  const titles = document.querySelectorAll('.video_title_videowise_app');
  if (!titles.length) return;

  titles.forEach((title) => {
    const widget = title.parentElement && title.parentElement.querySelector('[id^="reeview-app-widget"]');
    if (!widget) return;

    const update = () => title.classList.toggle('has-videos', widget.offsetHeight > 0);
    update();
    if ('ResizeObserver' in window) new ResizeObserver(update).observe(widget);
  });
})();
